<template>
  <div class="wrapper">
    <draggable v-model="list">
      <div class="tag"
           v-for="item in list"
           :key="getRowKey(item)">{{ renderItem(item) }}
        <Icon type="ios-menu-outline"
              class="icon" />
      </div>
    </draggable>
    <p>{{$t('components_form_items_drag_list_index_9')}}</p>
  </div>
</template>

<script>
import i18n from '../../../locales/index'

import draggable from 'vuedraggable';
import { isEqual } from 'lodash';
export default {
  name: 'form_draggable',
  components: {
    draggable
  },
  data () {
    return {
      premitive: false,
      list: [],
    };
  },
  props: [
    'value',
    'renderItem',// 自定义字段显示内容
    'getRowKey',
  ],
  watch: {
    value: {
      immediate: true,
      handler (value) {
        if (!Array.isArray(value)) {
          console.error('value must be an array');
          this.list = [];
        }
        this.list = value;
      }
    },
    list: {
      deep: true,
      handler (value) {
        if (isEqual(value, this.value)) {
          return;
        }
        this.$emit('input', value);
        this.$emit('on-change', value);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .tag {
    padding: 0 20px;
    margin-right: 8px;
    cursor: pointer;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    user-select: none;
    max-width: 500px;
    transition: all 0.3s ease;
    background: #fff;
    border: 1px solid #ddd;
    color: #666;
    margin-bottom: 2px;
  }
  p {
    color: #2d8cf0;
    font-size: 12px;
  }
  .icon {
    float: right;
    position: relative;
    line-height: 36px;
    font-size: 20px;
    color: #ccc;
    &:active {
      transform: scale(1.1);
    }
  }
}
</style>